import { render, staticRenderFns } from "./StudentDialog.vue?vue&type=template&id=1c369ad6&scoped=true"
import script from "./StudentDialog.vue?vue&type=script&lang=js"
export * from "./StudentDialog.vue?vue&type=script&lang=js"
import style0 from "./StudentDialog.vue?vue&type=style&index=0&id=1c369ad6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c369ad6",
  null
  
)

export default component.exports